import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const submitContactForm = async (formData) => {
    try {
        console.log('Sending to:', `${API_URL}/contact`);
        console.log('Form data:', formData);

        const response = await axios.post(`${API_URL}/contact`, formData, {
            headers: {
                'Content-Type': 'application/json',
            }
        });

        console.log('Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error submitting form:', error.response || error);
        throw error;
    }
};
